import { z } from "zod";

const ACCEPTED_IMAGE_TYPES = ["jpeg", "jpg", "png", "webp"];
const ImgSchema = z.object({
  fileName: z.string(),
  name: z.string(),
  fileSize: z.number(),
  size: z.number(),
  key: z.string(),
});
export const IMG_MAX_LIMIT = 1;

export const gallerieSchema = z.object({
  title: z
    .string({ required_error: "Le titre est obligatoire" })
    .min(3, { message: "Le titre doit comporter au moins 3 caractères." }),
  image: z
    .array(ImgSchema, { required_error: "L'image est obligatoire" })
    .max(IMG_MAX_LIMIT, {
      message: "Vous ne pouvez ajouter qu'une seule image.",
    })
    .min(1, { message: "Au moins une image doit être ajoutée." })
    .refine(
      (images) => {
        const invalidImages = images.filter((img) => {
          const fileExtension = img.fileName.split(".").pop()?.toLowerCase();
          return fileExtension && !ACCEPTED_IMAGE_TYPES.includes(fileExtension);
        });
        return invalidImages.length === 0;
      },
      {
        message: "Le type de fichier de l'image n'est pas pris en charge.",
      }
    ),
});

export type GallerieFormValues = z.infer<typeof gallerieSchema>;

export const updateGallerieSchema = z
  .object({
    title: z
      .string()
      .min(3, { message: "Le titre doit comporter au moins 3 caractères." })
      .optional(),
    image: z
      .array(ImgSchema)
      .max(IMG_MAX_LIMIT, {
        message: "Vous ne pouvez ajouter qu'une seule image.",
      })
      .min(1, { message: "Au moins une image doit être ajoutée." })
      .refine(
        (images) => {
          const invalidImages = images.filter((img) => {
            const fileExtension = img.fileName.split(".").pop()?.toLowerCase();
            return (
              fileExtension && !ACCEPTED_IMAGE_TYPES.includes(fileExtension)
            );
          });
          return invalidImages.length === 0;
        },
        {
          message: "Le type de fichier de l'image n'est pas pris en charge.",
        }
      ),
  })
  .partial();

export type UpdateGallerieFormValues = z.infer<typeof updateGallerieSchema>;
